export const DEMO_MODE_KEY = "grachDemoMode";
export const DEMO_USED_KEY = "grachDemoBetUsed";

export const isDemoModeEnabled = () => {
    try {
        return sessionStorage.getItem(DEMO_MODE_KEY) === "1";
    } catch {
        return false;
    }
};

export const enableDemoMode = () => {
    try {
        sessionStorage.setItem(DEMO_MODE_KEY, "1");
    } catch {
    }
};

export const markDemoBetUsedLocal = () => {
    try {
        sessionStorage.setItem(DEMO_USED_KEY, "1");
    } catch {
    }
};

export const isDemoBetUsedLocal = () => {
    try {
        return sessionStorage.getItem(DEMO_USED_KEY) === "1";
    } catch {
        return false;
    }
};
